import { Link } from "react-router-dom";
import { ArrowUpRight, Download } from "lucide-react";
import { motion } from "framer-motion";

export default function CTABanner() {
  return (
    <section className="relative py-28 bg-white" data-testid="cta-banner">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="bg-[#0A1F3F] text-white p-10 sm:p-16 lg:p-20 relative overflow-hidden"
        >
          <div className="absolute -right-20 -top-20 w-80 h-80 bg-[#F37021]/20 rounded-full blur-3xl pointer-events-none" />
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
            <div className="md:col-span-8">
              <div className="flex items-center gap-3 mb-5">
                <span className="w-10 h-px bg-[#F37021]" />
                <span className="text-eyebrow text-[#F37021]">Let's Talk</span>
              </div>
              <h3 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
                Ready to source with a professional trading house?
              </h3>
              <p className="mt-6 text-white/80 max-w-2xl leading-relaxed">
                Submit your inquiry and a senior trader will respond with a
                tailored quote — usually within a few hours, across time zones.
              </p>
            </div>
            <div className="md:col-span-4 flex md:justify-end flex-wrap gap-3">
              <Link
                to="/quote"
                data-testid="cta-banner-quote"
                className="inline-flex items-center gap-3 bg-[#F37021] hover:bg-[#D35F16] text-white px-8 py-5 text-xs uppercase tracking-[0.2em] font-semibold transition-colors"
              >
                Request a Quote
                <ArrowUpRight className="w-4 h-4" />
              </Link>
              <Link
                to="/company-profile"
                data-testid="cta-banner-profile"
                className="inline-flex items-center gap-3 border border-white/40 hover:bg-white hover:text-[#0A1F3F] text-white px-8 py-5 text-xs uppercase tracking-[0.2em] font-semibold transition-colors"
              >
                <Download className="w-4 h-4" />
                Company Profile
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
